export default __webpack_public_path__ + "static/media/juegosemanas_perder.3b8291cc.png";